module.exports = __webpack_public_path__ + "img/masterCard.b84a1005.svg";